
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-[#1A2B4A] via-[#2A3B5A] to-[#1A2B4A] overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/9446da9b7e46a938214eb70085dfb2b3.jpg')] bg-cover bg-center opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-24 sm:py-32 w-full">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="text-white space-y-6 sm:space-y-8">
            <div className="space-y-2 sm:space-y-4">
              <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold leading-tight">
                Elektro Tomasevic
              </h1>
              <h3 className="text-3xl sm:text-4xl md:text-6xl font-serif italic text-[#F4B942]">
                Ihr Fachbetrieb&nbsp;in Wien
              </h3>
            </div>

            <p className="text-lg sm:text-xl md:text-2xl text-gray-200">
              Präzision seit 2013
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href="#kontakt"
                className="bg-[#F4B942] text-[#1A2B4A] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-[#e5a832] transition-all duration-300 hover:shadow-xl hover:scale-105 text-center whitespace-nowrap"
              >
                Jetzt Beratung anfragen
              </a>
              <a
                href="tel:+436991223301"
                className="border-2 border-[#F4B942] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg hover:bg-[#F4B942] hover:text-[#1A2B4A] transition-all duration-300 text-center whitespace-nowrap"
              >
                +43 699 122 333 01
              </a>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20photovoltaic%20solar%20panel%20installation%20on%20modern%20austrian%20building%20rooftop%20in%20vienna%20with%20stephansdom%20cathedral%20visible%20in%20background%20bright%20sunny%20day%20high%20quality%20technical%20photography%20clean%20professional%20electrical%20engineering%20work%20urban%20vienna%20cityscape&width=800&height=600&seq=hero-main-pv-installation&orientation=landscape"
                alt="Photovoltaik Installation in Wien"
                className="rounded-3xl shadow-2xl object-cover object-top w-full h-[500px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
